// document.addEventListener("DOMContentLoaded", () => {

//     document.querySelectorAll(".ahs-product-card, .pd, #team-store").forEach(card => {

//         const variantJson = card.querySelector(".product-variants");
//         if (!variantJson) return;

//         let variants = [];
//         try {
//             variants = JSON.parse(variantJson.textContent);
//         } catch (e) {
//             console.error("Failed to parse variants JSON", e);
//             //alert("Error: Could not parse product-variants JSON!");
//             return;
//         }

//         if (!variants || variants.length === 0) return;

//         let currentVariant = variants[0];
//         let selectedOptions = {};

//         /* ---------- Elements ---------- */
//         const image = card.querySelector(".product-main-image, #pdMainImg, #pdStage");
//         const sku = card.querySelector(".variant-sku");
//         const price = card.querySelector(".variant-price, #productPrice");
//         const addBtn = card.querySelector(".add-cart-btn, .team-add-to-cart");
//         const qtyInput = card.querySelector(".qty-input");
//         const variantInput = card.querySelector(".variant-id");

//         const colorLabel = card.querySelector("#colorLabel");
//         const sizeLabel = card.querySelector("#sizeLabel");

//         const teamSlug = card.dataset.teamSlug || "";
//         const moneyFormat = card.dataset.moneyFormat || "";

//         /* ---------- Helper: Flexible Matcher ---------- */
//         function matchOption(variantOptions, targetValue) {
//             if (!targetValue) return true;
//             const target = String(targetValue).trim().toLowerCase();
//             return variantOptions.some(opt => String(opt).trim().toLowerCase() === target);
//         }

//         /* ---------- Helper: Money Formatter ---------- */
//         function formatMoney(cents, formatStr) {
//             if (typeof cents === 'string') cents = cents.replace('.', '');
//             const centsVal = parseFloat(cents);
//             const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

//             if (formatStr && placeholderRegex.test(formatStr)) {
//                 function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
//                     if (isNaN(number) || number == null) return "0";
//                     number = (number / 100).toFixed(precision);
//                     const parts = number.split('.');
//                     const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
//                     const formattedCents = parts[1] ? decimal + parts[1] : '';
//                     return dollars + formattedCents;
//                 }

//                 const match = formatStr.match(placeholderRegex);
//                 let formattedValue = '';
//                 switch (match[1]) {
//                     case 'amount':
//                         formattedValue = formatWithDelimiters(centsVal, 2);
//                         break;
//                     case 'amount_no_decimals':
//                         formattedValue = formatWithDelimiters(centsVal, 0);
//                         break;
//                     case 'amount_with_comma_separator':
//                         formattedValue = formatWithDelimiters(centsVal, 2, '.', ',');
//                         break;
//                     case 'amount_no_decimals_with_space_separator':
//                         formattedValue = formatWithDelimiters(centsVal, 0, ' ');
//                         break;
//                     default:
//                         formattedValue = formatWithDelimiters(centsVal, 2);
//                 }
//                 return formatStr.replace(placeholderRegex, formattedValue);
//             }

//             return new Intl.NumberFormat("en-US", {
//                 style: "currency",
//                 currency: "USD"
//             }).format(centsVal / 100);
//         }

//         /* ---------- Initial Active Options Setup ---------- */
//         let activeSize = card.querySelector(".size-btn.active, .sizeway .is-on");
//         if (!activeSize) {
//             activeSize = card.querySelector(".size-btn, .size-options button, .sizeway button");
//             if (activeSize) {
//                 activeSize.classList.add("active");
//                 activeSize.setAttribute("aria-pressed", "true");
//             }
//         }
//         if (activeSize) {
//             selectedOptions.Size = activeSize.dataset.optionValue || activeSize.textContent.trim();
//             if (sizeLabel) sizeLabel.textContent = selectedOptions.Size;
//         }

//         let activeColor = card.querySelector(".color-btn.active, .colorway .is-on");
//         if (!activeColor) {
//             activeColor = card.querySelector(".color-btn, .swatch, .color-options button, .colorway button");
//             if (activeColor) {
//                 activeColor.classList.add("active");
//                 activeColor.setAttribute("aria-pressed", "true");
//             }
//         }
//         if (activeColor) {
//             selectedOptions.Color = activeColor.dataset.optionValue || activeColor.dataset.name || activeColor.title;
//             if (colorLabel) colorLabel.textContent = selectedOptions.Color;
//         }

//         updateVariant(false);

//         /* =====================================================
//            EVENT DELEGATION (Click Color, Size, Quantity)
//         ===================================================== */
//         card.addEventListener("click", (e) => {

//             // COLOR CLICK
//             const colorBtn = e.target.closest(".color-btn, .swatch, [data-option-name='Color'], .color-options button, .colorway button");
//             if (colorBtn) {
//                 card.querySelectorAll(".color-btn, .swatch, .color-options button, .colorway button").forEach(b => {
//                     b.classList.remove("active", "is-on");
//                     b.setAttribute("aria-pressed", "false");
//                 });

//                 colorBtn.classList.add("active", "is-on");
//                 colorBtn.setAttribute("aria-pressed", "true");

//                 const clickedColor = colorBtn.dataset.optionValue || colorBtn.dataset.name || colorBtn.title || colorBtn.textContent.trim();
//                 selectedOptions.Color = clickedColor;

//                 if (colorLabel) colorLabel.textContent = clickedColor;

//                 // Trigger update AND alert debugging box
//                 updateVariant(true);
//                 return;
//             }

//             // SIZE CLICK
//             const sizeBtn = e.target.closest(".size-btn, .size-chip, [data-option-name='Size'], .size-options button, .sizeway button");
//             if (sizeBtn) {
//                 card.querySelectorAll(".size-btn, .size-chip, .size-options button, .sizeway button").forEach(b => {
//                     b.classList.remove("active", "is-on");
//                     b.setAttribute("aria-pressed", "false");
//                 });

//                 sizeBtn.classList.add("active", "is-on");
//                 sizeBtn.setAttribute("aria-pressed", "true");

//                 const clickedSize = sizeBtn.dataset.optionValue || sizeBtn.textContent.trim();
//                 selectedOptions.Size = clickedSize;

//                 if (sizeLabel) sizeLabel.textContent = clickedSize;

//                 updateVariant(false);
//                 return;
//             }

//             card.querySelectorAll(".fabric-btn").forEach(btn => {
//     btn.addEventListener("click", () => {
//         selectedOptions.Fabric = btn.dataset.optionValue;

//         card.querySelectorAll(".fabric-btn").forEach(b => {
//             const active = b === btn;
//             b.classList.toggle("active", active);
//             b.classList.toggle("is-on", active);
//             b.setAttribute("aria-pressed", active ? "true" : "false");
//         });

//         updateVariant();
//     });
// });

//             // QTY PLUS
//             if (e.target.closest(".qty-plus") && qtyInput) {
//                 qtyInput.value = Number(qtyInput.value) + 1;
//             }

//             // QTY MINUS
//             if (e.target.closest(".qty-minus") && qtyInput) {
//                 const qty = Number(qtyInput.value);
//                 if (qty > 1) qtyInput.value = qty - 1;
//             }
//         });

//         /* =====================================================
//            UPDATE VARIANT LOGIC
//         ===================================================== */
//         function updateVariant(showAlert = false) {
//             // Find variant by Size & Color
//             let variant = variants.find(v => {
//                 let match = true;
//                 if (selectedOptions.Size)
//                     match = match && matchOption(v.options, selectedOptions.Size);
//                 if (selectedOptions.Color)
//                     match = match && matchOption(v.options, selectedOptions.Color);
//                 if (selectedOptions.Fabric)
//         match = match && matchOption(v.options, selectedOptions.Fabric);
//                 return match;
//             });

//             // Fallback match by Color
//             if (!variant && selectedOptions.Color) {
//                 variant = variants.find(v => matchOption(v.options, selectedOptions.Color));
//                 if (variant) {
//                     const availableSize = variant.options.find(opt => !matchOption([opt], selectedOptions.Color));
//                     if (availableSize) {
//                         selectedOptions.Size = availableSize;
//                         if (sizeLabel) sizeLabel.textContent = availableSize;

//                         card.querySelectorAll(".size-btn, .size-chip, .size-options button, .sizeway button").forEach(b => {
//                             const val = b.dataset.optionValue || b.textContent.trim();
//                             const isActive = String(val).trim().toLowerCase() === String(availableSize).trim().toLowerCase();
//                             b.classList.toggle("active", isActive);
//                             b.classList.toggle("is-on", isActive);
//                             b.setAttribute("aria-pressed", isActive ? "true" : "false");
//                         });
//                     }
//                 }
//             }

//             if (!variant) variant = variants[0];
//             if (!variant) return;

//             currentVariant = variant;

//             // --- ALERT POPUP FOR TESTING ---
//             if (showAlert) {
//                 // alert(
//                 //     "🎨 Color Swatch Clicked!\n\n" +
//                 //     "Selected Color: " + selectedOptions.Color + "\n" +
//                 //     "Selected Size: " + (selectedOptions.Size || "N/A") + "\n\n" +
//                 //     "Matched Variant ID: " + variant.id + "\n" +
//                 //     "Variant Price: " + formatMoney(variant.price, moneyFormat) + "\n\n" +
//                 //     "Variant Image URL:\n" + (variant.image || "No image URL in JSON")
//                 // );
//             }

//             // Update Image & Details
//             if (sku) sku.textContent = variant.sku || "";
//             if (price) price.textContent = formatMoney(variant.price, moneyFormat);
//             if (image && variant.image) {
//                 image.src = variant.image;
//             }
//             if (variantInput) variantInput.value = variant.id;

//             if (addBtn) {
//                 addBtn.dataset.variantId = variant.id;
//                 addBtn.disabled = !variant.available;
//                 addBtn.textContent = variant.available ? "Add to cart" : "Sold Out";
//             }
//         }

//         /* =====================================================
//            AJAX ADD TO CART
//         ===================================================== */
//         if (addBtn) {
//             addBtn.addEventListener("click", async () => {
//                 if (!currentVariant || !currentVariant.available) return;

//                 addBtn.classList.add("loading");
//                 addBtn.textContent = "Adding...";

//                 try {
//                     if (teamSlug) {
//                         const updateRes = await fetch("/cart/update.js", {
//                             method: "POST",
//                             headers: { "Content-Type": "application/json" },
//                             body: JSON.stringify({ attributes: { team_slug: teamSlug } })
//                         });
//                         if (!updateRes.ok) {
//     throw new Error(await updateRes.text());
// }
//                     }

//                     const addRes =  await fetch("/cart/add.js", {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify({
//                             id: currentVariant.id,
//                             quantity: qtyInput ? Number(qtyInput.value) : 1,
//                             properties: teamSlug ? { Team: teamSlug } : {}
//                         })
//                     });

//                     if (!addRes.ok) {
//     throw new Error(await addRes.text());
// }

//                     window.location.href = "/cart";
//                 } catch (e) {
//                     console.error("Add to cart error:", e);
//                     alert(e.message || "Unable to add product.");
//                 } finally {
//                     addBtn.classList.remove("loading");
//                     addBtn.textContent = currentVariant.available ? "Add to cart" : "Sold Out";
//                 }
//             });
//         }

//     });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   // Target ONLY product cards (skipping container wrappers like #team-store)
//   document.querySelectorAll(".ahs-product-card, .pd").forEach((card) => {
//     if (!card) return;

//     const variantJson = card.querySelector(".product-variants");
//     if (!variantJson) return;

//     const optionJson = card.querySelector(".product-options");

//     let variants = [];
//     let productOptions = [];

//     try {
//       variants = JSON.parse(variantJson.textContent);
//       if (optionJson) {
//         productOptions = JSON.parse(optionJson.textContent);
//       }
//     } catch (e) {
//       console.error("Failed parsing product JSON:", e);
//       return;
//     }

//     if (!variants.length) return;

//     // Index options dynamically based on JSON position
//     const optionIndex = {};
//     productOptions.forEach((name, index) => {
//       optionIndex[name] = index;
//     });

//     let currentVariant = variants[0];
//     let selectedOptions = {};

//     /* =====================================
//         SCOPED DOM ELEMENTS
//     ====================================== */
//     const image = card.querySelector(".product-main-image");
//     const sku = card.querySelector(".variant-sku");
//     const price = card.querySelector(".variant-price, .productPrice");
//     const addBtn = card.querySelector(".add-cart-btn, .team-add-to-cart");
//     const qtyInput = card.querySelector(".qty-input");
//     const variantInput = card.querySelector(".variant-id");

//     const colorLabel = card.querySelector(".color-label, #colorLabel");
//     const sizeLabel = card.querySelector(".size-label, #sizeLabel");
//     const fabricLabel = card.querySelector(".fabric-label, #fabricLabel");

//     const teamSlug = card.dataset.teamSlug || "";
//     const moneyFormat = card.dataset.moneyFormat || "";

//     /* =====================================
//         MONEY FORMATTING
//     ====================================== */
//     function formatMoney(cents, formatStr) {
//       if (typeof cents === "string") cents = cents.replace(".", "");
//       cents = parseFloat(cents);

//       const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

//       if (formatStr && placeholderRegex.test(formatStr)) {
//         function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
//           if (isNaN(number)) return "0";
//           number = (number / 100).toFixed(precision);
//           const parts = number.split(".");
//           const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
//           return dollars + (parts[1] ? decimal + parts[1] : "");
//         }

//         const match = formatStr.match(placeholderRegex);
//         let value = "";

//         switch (match[1]) {
//           case "amount":
//             value = formatWithDelimiters(cents, 2);
//             break;
//           case "amount_no_decimals":
//             value = formatWithDelimiters(cents, 0);
//             break;
//           case "amount_with_comma_separator":
//             value = formatWithDelimiters(cents, 2, ".", ",");
//             break;
//           default:
//             value = formatWithDelimiters(cents, 2);
//         }
//         return formatStr.replace(placeholderRegex, value);
//       }

//       return new Intl.NumberFormat("en-US", {
//         style: "currency",
//         currency: "USD",
//       }).format(cents / 100);
//     }

//     /* =====================================
//         INITIAL ACTIVE OPTION STATE
//     ====================================== */
//     card.querySelectorAll(
//       ".color-btn.active, .swatch.active, .size-btn.active, .size-chip.active, .fabric-btn.active, .is-on"
//     ).forEach((activeBtn) => {
//       const optName =
//         activeBtn.dataset.optionName ||
//         (activeBtn.classList.contains("fabric-btn") ? "Fabric" :
//          activeBtn.classList.contains("size-btn") || activeBtn.classList.contains("size-chip") ? "Size" : "Color");

//       const optValue =
//         activeBtn.dataset.optionValue ||
//         activeBtn.dataset.name ||
//         activeBtn.title ||
//         activeBtn.textContent.trim();

//       const matchedKey = productOptions.find(
//         (opt) => opt.toLowerCase() === optName.toLowerCase()
//       ) || optName;

//       selectedOptions[matchedKey] = optValue;
//     });

//     /* =====================================
//         UPDATE VARIANT & TOGGLE CLASSES
//     ====================================== */
//     function updateVariant() {
//       let variant = variants.find((v) => {
//         for (const optionName in optionIndex) {
//           const index = optionIndex[optionName];
//           const selectedValue = selectedOptions[optionName];

//           if (
//             selectedValue &&
//             String(v.options[index]).trim().toLowerCase() !==
//               String(selectedValue).trim().toLowerCase()
//           ) {
//             return false;
//           }
//         }
//         return true;
//       });

//       // if (!variant) variant = variants[0];
//       // if (!variant) return;

//       if (!variant) {
//   console.warn("No matching variant found:", selectedOptions);
//   return;
// }

//       currentVariant = variant;

//       // Sync active variant values into selectedOptions
//       productOptions.forEach((optionName, index) => {
//         selectedOptions[optionName] = variant.options[index];
//       });

//       // Update button active/is-on states
//       card.querySelectorAll(
//         ".color-btn, .swatch, .size-btn, .size-chip, .fabric-btn, [data-option-name]"
//       ).forEach((btn) => {
//         const btnOptionName =
//           btn.dataset.optionName ||
//           (btn.classList.contains("fabric-btn") ? "Fabric" :
//            btn.classList.contains("size-btn") || btn.classList.contains("size-chip") ? "Size" : "Color");

//         const btnValue =
//           btn.dataset.optionValue ||
//           btn.dataset.name ||
//           btn.title ||
//           btn.textContent.trim();

//         const activeSelectedKey = Object.keys(selectedOptions).find(
//           (key) => key.toLowerCase() === btnOptionName.toLowerCase()
//         );

//         const isActive =
//           activeSelectedKey &&
//           String(selectedOptions[activeSelectedKey]).trim().toLowerCase() ===
//             String(btnValue).trim().toLowerCase();

//         btn.classList.toggle("active", isActive);
//         btn.classList.toggle("is-on", isActive);
//         btn.setAttribute("aria-pressed", isActive ? "true" : "false");
//       });

//       // Update UI Labels
//       if (colorLabel && selectedOptions.Color) colorLabel.textContent = selectedOptions.Color;
//       if (sizeLabel && selectedOptions.Size) sizeLabel.textContent = selectedOptions.Size;
//       if (fabricLabel && selectedOptions.Fabric) fabricLabel.textContent = selectedOptions.Fabric;

//       // Update Product Details
//       if (sku) sku.textContent = variant.sku || "";
//       if (price) price.innerHTML = formatMoney(variant.price, moneyFormat);
//       if (image && variant.image) image.src = variant.image;
//       if (variantInput) variantInput.value = variant.id;

//       if (addBtn) {
//         addBtn.dataset.variantId = variant.id;
//         addBtn.disabled = !variant.available;
//         addBtn.textContent = variant.available ? "Add to cart" : "Sold Out";
//       }
      
//     }

//     /* =====================================
//         DYNAMIC EVENT LISTENERS
//     ====================================== */
//     card.addEventListener("click", (e) => {
//       const optionBtn = e.target.closest(
//         ".color-btn, .swatch, .size-btn, .size-chip, .fabric-btn, [data-option-name]"
//       );

//       if (optionBtn) {
//         const optionName =
//           optionBtn.dataset.optionName ||
//           (optionBtn.classList.contains("fabric-btn") ? "Fabric" :
//            optionBtn.classList.contains("size-btn") || optionBtn.classList.contains("size-chip") ? "Size" : "Color");

//         const optionValue =
//           optionBtn.dataset.optionValue ||
//           optionBtn.dataset.name ||
//           optionBtn.title ||
//           optionBtn.textContent.trim();

//         const matchedKey = productOptions.find(
//           (opt) => opt.toLowerCase() === optionName.toLowerCase()
//         ) || optionName;

//         selectedOptions[matchedKey] = optionValue;
//         updateVariant();
//         return;
//       }

//       /* ---------- QTY ADJUSTMENTS ---------- */
//       if (e.target.closest(".qty-plus") && qtyInput) {
//         qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 0) + 1);
//       }

//       if (e.target.closest(".qty-minus") && qtyInput) {
//         qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 2) - 1);
//       }
//     });

//     // Run initial variant setup on page load
//     updateVariant();

//     /* =====================================
//         AJAX ADD TO CART
//     ====================================== */
//     if (addBtn) {
//       addBtn.addEventListener("click", async (e) => {
//         e.preventDefault();

//         if (!currentVariant || !currentVariant.available) return;

//         addBtn.disabled = true;
//         addBtn.classList.add("loading");
//         addBtn.textContent = "Adding...";

//         try {
//           if (teamSlug) {
//             const updateRes = await fetch("/cart/update.js", {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 attributes: { team_slug: teamSlug },
//               }),
//             });

//             if (!updateRes.ok) throw new Error(await updateRes.text());
//           }

//           const parsedQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
//           const quantity = isNaN(parsedQty) || parsedQty < 1 ? 1 : parsedQty;

//           const addRes = await fetch("/cart/add.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               id: currentVariant.id,
//               quantity: quantity,
//               properties: teamSlug ? { Team: teamSlug } : {},
//             }),
//           });

//           if (!addRes.ok) throw new Error(await addRes.text());

//           window.location.href = "/cart";
//         } catch (err) {
//           console.error("Cart error:", err);
//           alert(err.message || "Unable to add product to cart.");
//         } finally {
//           addBtn.disabled = !currentVariant.available;
//           addBtn.classList.remove("loading");
//           addBtn.textContent = currentVariant.available ? "Add to cart" : "Sold Out";
//         }
//       });
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ahs-product-card, .pd").forEach((card) => {
    // Prevent duplicate event binding on page re-renders / AJAX updates
    if (!card || card.dataset.variantInitialized) return;
    card.dataset.variantInitialized = "true";

    const variantJson = card.querySelector(".product-variants");
    if (!variantJson) return;

    const optionJson = card.querySelector(".product-options");

    let variants = [];
    let productOptions = [];

    try {
      variants = JSON.parse(variantJson.textContent);
      if (optionJson) {
        productOptions = JSON.parse(optionJson.textContent);
      }
    } catch (e) {
      console.error("Failed parsing product JSON:", e);
      return;
    }

    if (!variants.length) return;

    const optionIndex = {};
    productOptions.forEach((name, index) => {
      optionIndex[name] = index;
    });

    const addBtn = card.querySelector(".add-cart-btn, .team-add-to-cart");
    const initialVariantId = addBtn ? parseInt(addBtn.dataset.variantId, 10) : null;

    // Detect default variant selected by Liquid
    let currentVariant = variants.find((v) => v.id === initialVariantId) || variants[0];
    let selectedOptions = {};

    // Populate initial option state directly from currentVariant
    productOptions.forEach((optionName, index) => {
      selectedOptions[optionName] = currentVariant.options[index];
    });

    /* =====================================
        SCOPED DOM ELEMENTS
    ====================================== */
    const image = card.querySelector(".product-main-image");
    const sku = card.querySelector(".variant-sku");
    const price = card.querySelector(".variant-price, .productPrice");
    const qtyInput = card.querySelector(".qty-input");
    const variantInput = card.querySelector(".variant-id");

    const colorLabel = card.querySelector(".color-label, #colorLabel");
    const sizeLabel = card.querySelector(".size-label, #sizeLabel");
    const fabricLabel = card.querySelector(".fabric-label, #fabricLabel");

    const teamSlug = card.dataset.teamSlug || "";
    const moneyFormat = card.dataset.moneyFormat || "";

    /* =====================================
        MONEY FORMATTING
    ====================================== */
    function formatMoney(cents, formatStr) {
      if (typeof cents === "string") cents = cents.replace(".", "");
      cents = parseFloat(cents);

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      if (formatStr && placeholderRegex.test(formatStr)) {
        function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
          if (isNaN(number)) return "0";
          number = (number / 100).toFixed(precision);
          const parts = number.split(".");
          const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
          return dollars + (parts[1] ? decimal + parts[1] : "");
        }

        const match = formatStr.match(placeholderRegex);
        let value = "";

        switch (match[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          default:
            value = formatWithDelimiters(cents, 2);
        }
        return formatStr.replace(placeholderRegex, value);
      }

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
    }

    /* =====================================
        UPDATE VARIANT & TOGGLE CLASSES
    ====================================== */
    function updateVariant(changedOptionName = null) {
      // Find exact match for selected options
      let variant = variants.find((v) => {
        return productOptions.every((optionName, index) => {
          const selectedValue = selectedOptions[optionName];
          return (
            !selectedValue ||
            String(v.options[index]).trim().toLowerCase() ===
              String(selectedValue).trim().toLowerCase()
          );
        });
      });

      // Fallback: If clicked option combination doesn't exist, pick first variant matching newly clicked option
      if (!variant && changedOptionName) {
        const changedIdx = optionIndex[changedOptionName];
        const changedVal = selectedOptions[changedOptionName];
        variant = variants.find(
          (v) =>
            String(v.options[changedIdx]).trim().toLowerCase() ===
            String(changedVal).trim().toLowerCase()
        );
      }

      if (!variant) variant = variants[0];
      currentVariant = variant;

      // Sync active variant values back into selectedOptions
      productOptions.forEach((optionName, index) => {
        selectedOptions[optionName] = variant.options[index];
      });

      // Update button active / is-on states across all option buttons
      card.querySelectorAll(
        ".color-btn, .swatch, .size-btn, .size-chip, .fabric-btn, [data-option-name]"
      ).forEach((btn) => {
        const btnOptionName =
          btn.dataset.optionName ||
          (btn.classList.contains("fabric-btn")
            ? "Fabric"
            : btn.classList.contains("size-btn") || btn.classList.contains("size-chip")
            ? "Size"
            : "Color");

        const btnValue =
          btn.dataset.optionValue ||
          btn.dataset.name ||
          btn.title ||
          btn.textContent.trim();

        const activeSelectedKey = Object.keys(selectedOptions).find(
          (key) => key.toLowerCase() === btnOptionName.toLowerCase()
        );

        const isActive =
          activeSelectedKey &&
          String(selectedOptions[activeSelectedKey]).trim().toLowerCase() ===
            String(btnValue).trim().toLowerCase();

        btn.classList.toggle("active", isActive);
        btn.classList.toggle("is-on", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      // Update Option Labels
      if (colorLabel && selectedOptions.Color) colorLabel.textContent = selectedOptions.Color;
      if (sizeLabel && selectedOptions.Size) sizeLabel.textContent = selectedOptions.Size;
      if (fabricLabel && selectedOptions.Fabric) fabricLabel.textContent = selectedOptions.Fabric;

      // Update Product Details
      if (sku) sku.textContent = variant.sku || "";
      if (price) price.innerHTML = formatMoney(variant.price, moneyFormat);
      if (image && variant.image) image.src = variant.image;
      if (variantInput) variantInput.value = variant.id;

      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? "Add to cart" : "Sold Out";
      }
    }

    /* =====================================
        DELEGATED EVENT HANDLERS
    ====================================== */
    card.addEventListener("click", async (e) => {
      // 1. OPTION SELECTION
      const optionBtn = e.target.closest(
        ".color-btn, .swatch, .size-btn, .size-chip, .fabric-btn, [data-option-name]"
      );

      if (optionBtn) {
        const optionName =
          optionBtn.dataset.optionName ||
          (optionBtn.classList.contains("fabric-btn")
            ? "Fabric"
            : optionBtn.classList.contains("size-btn") || optionBtn.classList.contains("size-chip")
            ? "Size"
            : "Color");

        const optionValue =
          optionBtn.dataset.optionValue ||
          optionBtn.dataset.name ||
          optionBtn.title ||
          optionBtn.textContent.trim();

        const matchedKey =
          productOptions.find((opt) => opt.toLowerCase() === optionName.toLowerCase()) ||
          optionName;

        selectedOptions[matchedKey] = optionValue;
        updateVariant(matchedKey);
        return;
      }

      // 2. QTY ADJUSTMENTS
      if (e.target.closest(".qty-plus") && qtyInput) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 0) + 1);
        return;
      }

      if (e.target.closest(".qty-minus") && qtyInput) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 2) - 1);
        return;
      }

      // 3. ADD TO CART
      const clickAddBtn = e.target.closest(".add-cart-btn, .team-add-to-cart");
      if (clickAddBtn) {
        e.preventDefault();
        e.stopPropagation();

        // Prevent duplicate network calls or clicks while loading/sold out
        if (
          clickAddBtn.dataset.loading === "true" ||
          !currentVariant ||
          !currentVariant.available
        ) {
          return;
        }

        clickAddBtn.dataset.loading = "true";
        clickAddBtn.disabled = true;
        clickAddBtn.classList.add("loading");
        const originalText = clickAddBtn.textContent;
        clickAddBtn.textContent = "Adding...";

        try {
          const parsedQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          const quantity = isNaN(parsedQty) || parsedQty < 1 ? 1 : parsedQty;

          // Single Ajax call sending attributes & properties together
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: currentVariant.id,
              quantity: quantity,
              properties: teamSlug ? { Team: teamSlug } : {},
              attributes: teamSlug ? { team_slug: teamSlug } : {},
            }),
          });

          if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText);
          }

          window.location.href = "/cart";
        } catch (err) {
          console.error("Cart error:", err);
          alert(err.message || "Unable to add product to cart.");

          clickAddBtn.dataset.loading = "false";
          clickAddBtn.disabled = !currentVariant.available;
          clickAddBtn.classList.remove("loading");
          clickAddBtn.textContent = currentVariant.available ? originalText : "Sold Out";
        }
      }
    });

    // Initialize initial active variant state on load
    updateVariant();
  });
});